import { useMemo } from "react";
import { useClientPortalConfigContext } from "../../../context";
import { useWaitlistRequestConfiguration } from "./useWaitlistRequestConfiguration";

export function useWaitlistRequestData() {
    const { clientPortalGuid, clientPortalConfig } = useClientPortalConfigContext();
    const { data } = useWaitlistRequestConfiguration(clientPortalGuid);

    const locationOptions = useMemo(() => {
        if (!data?.locations) {
            return [];
        }

        const options = data.locations;
        if (options.length <= 1) return options;

        return [{ label: "Any Location", value: "any" }, ...options];
    }, [data]);

    const practitionerOptions = useMemo(() => {
        if (!data?.practitioners) {
            return [];
        }

        const options = data.practitioners;

        if (!clientPortalConfig.clientsCanBookWithAnyPractitioner || options.length == 1) {
            return options;
        }

        return [{ label: "Any Practitioner", value: "any" }, ...options];
    }, [data, clientPortalConfig]);

    return {
        locationOptions,
        practitionerOptions,
    };
}
